var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 1.07 71.275)",
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 25.25,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 .5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v2.188H.5V2c0-.414.168-.79.44-1.06C1.21.667 1.585.5 2 .5z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 1,
    y: 12,
    width: 8,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 2,
    y: 14,
    width: 6,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#595959",
    cx: 4.167,
    cy: 5.833,
    r: 3.667
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    fill: "#F2F2F2",
    d: "M7.083 0 10 5.833H4.167z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 3,
    y: 25,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 7,
    y: 25,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 11,
    y: 25,
    width: 2,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 .5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v2.5H.5V2c0-.414.168-.79.44-1.06C1.21.667 1.585.5 2 .5z",
    stroke: "#595959",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 6,
    y: 2,
    width: 4,
    height: 1,
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrApps);
export default __webpack_public_path__ + "static/media/icon-qr-apps.e16ed33378c0678d75633f4fcb01f688.svg";
export { ForwardRef as ReactComponent };